var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProblem5 = function SvgProblem5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111,
    height: 150,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__a)",
    fillRule: "evenodd",
    d: "M5.332 61.312a3.277 3.277 0 0 0-3.273 3.28 3.277 3.277 0 0 0 3.273 3.28 3.277 3.277 0 0 0 3.273-3.28 3.277 3.277 0 0 0-3.273-3.28M0 64.592a5.337 5.337 0 0 1 5.332-5.343 5.337 5.337 0 0 1 5.332 5.343 5.34 5.34 0 0 1-5.332 5.343A5.337 5.337 0 0 1 0 64.592",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__b)",
    fillRule: "evenodd",
    d: "M38.784 61.312a3.277 3.277 0 0 0-3.273 3.28 3.277 3.277 0 0 0 3.273 3.28 3.277 3.277 0 0 0 3.273-3.28 3.277 3.277 0 0 0-3.273-3.28m-5.332 3.28a5.34 5.34 0 0 1 5.332-5.343 5.337 5.337 0 0 1 5.332 5.343 5.337 5.337 0 0 1-5.332 5.343 5.34 5.34 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__c)",
    fillRule: "evenodd",
    d: "M5.332 82.437a3.277 3.277 0 0 0-3.273 3.28 3.277 3.277 0 0 0 3.273 3.28 3.277 3.277 0 0 0 3.273-3.28 3.277 3.277 0 0 0-3.273-3.28M0 85.717a5.337 5.337 0 0 1 5.332-5.343 5.337 5.337 0 0 1 5.332 5.343 5.34 5.34 0 0 1-5.332 5.343A5.337 5.337 0 0 1 0 85.717",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__d)",
    fillRule: "evenodd",
    d: "M38.784 82.437a3.277 3.277 0 0 0-3.273 3.28 3.277 3.277 0 0 0 3.273 3.28 3.277 3.277 0 0 0 3.273-3.28 3.277 3.277 0 0 0-3.273-3.28m-5.332 3.28a5.34 5.34 0 0 1 5.332-5.343 5.337 5.337 0 0 1 5.332 5.343 5.337 5.337 0 0 1-5.332 5.343 5.34 5.34 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__e)",
    fillRule: "evenodd",
    d: "M8.214 68.904v12.502H2.45V68.904z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__f)",
    fillRule: "evenodd",
    d: "M41.666 68.904v12.502h-5.764V68.904z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__g)",
    fillRule: "evenodd",
    d: "M72.216 61.312a3.277 3.277 0 0 0-3.273 3.28 3.277 3.277 0 0 0 3.273 3.28 3.277 3.277 0 0 0 3.273-3.28 3.277 3.277 0 0 0-3.273-3.28m-5.332 3.28a5.337 5.337 0 0 1 5.332-5.343 5.337 5.337 0 0 1 5.332 5.343 5.337 5.337 0 0 1-5.332 5.343 5.337 5.337 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__h)",
    fillRule: "evenodd",
    d: "M72.216 82.437a3.277 3.277 0 0 0-3.273 3.28 3.277 3.277 0 0 0 3.273 3.28 3.277 3.277 0 0 0 3.273-3.28 3.277 3.277 0 0 0-3.273-3.28m-5.332 3.28a5.337 5.337 0 0 1 5.332-5.343 5.337 5.337 0 0 1 5.332 5.343 5.337 5.337 0 0 1-5.332 5.343 5.337 5.337 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__i)",
    fillRule: "evenodd",
    d: "M75.098 68.904v12.502h-5.764V68.904z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__j)",
    fillRule: "evenodd",
    d: "M21.176 49.11 9.504 63.18 5.07 59.485l11.673-14.07z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__k)",
    fillRule: "evenodd",
    d: "M34.39 63.188 23.027 49.861l4.382-3.752 11.364 13.327z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__l)",
    fillRule: "evenodd",
    d: "M55.5 42.374a3.277 3.277 0 0 0-3.273 3.28 3.277 3.277 0 0 0 3.273 3.28 3.277 3.277 0 0 0 3.273-3.28 3.277 3.277 0 0 0-3.273-3.28m-5.332 3.28a5.337 5.337 0 0 1 5.332-5.343 5.337 5.337 0 0 1 5.332 5.343 5.337 5.337 0 0 1-5.332 5.343 5.337 5.337 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__m)",
    fillRule: "evenodd",
    d: "M54.755 50.141 43.556 63.386 39.16 59.65l11.198-13.244z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__n)",
    fillRule: "evenodd",
    d: "M67.567 63.044 56.224 50.48l4.275-3.876L71.84 59.168z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__o)",
    fillRule: "evenodd",
    d: "M22.048 100.777a3.277 3.277 0 0 0-3.273 3.28 3.276 3.276 0 0 0 3.273 3.28 3.276 3.276 0 0 0 3.273-3.28 3.277 3.277 0 0 0-3.273-3.28m-5.332 3.28a5.337 5.337 0 0 1 5.332-5.343 5.337 5.337 0 0 1 5.332 5.343 5.337 5.337 0 0 1-5.332 5.343 5.337 5.337 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__p)",
    fillRule: "evenodd",
    d: "M16.742 103.299 4.534 91.127 8.6 87.033l12.207 12.171z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__q)",
    fillRule: "evenodd",
    d: "m38.843 90.664-11.714 13.265-4.316-3.828 11.713-13.265z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__r)",
    fillRule: "evenodd",
    d: "M50.635 103.611 39.086 90.676l4.296-3.852L54.93 99.759z",
    clipRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__s)",
    fillRule: "evenodd",
    d: "m71.893 90.487-11.446 13.1-4.336-3.805 11.446-13.1z",
    clipRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__t)",
    fillRule: "evenodd",
    d: "M88.932 42.663a3.277 3.277 0 0 0-3.273 3.28 3.277 3.277 0 0 0 3.273 3.28 3.277 3.277 0 0 0 3.273-3.28 3.277 3.277 0 0 0-3.273-3.28m-5.332 3.28a5.34 5.34 0 0 1 5.332-5.343 5.34 5.34 0 0 1 5.331 5.343 5.337 5.337 0 0 1-5.331 5.343 5.337 5.337 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__u)",
    fillRule: "evenodd",
    d: "M105.668 61.622a3.277 3.277 0 0 0-3.273 3.28 3.277 3.277 0 0 0 3.273 3.28 3.276 3.276 0 0 0 3.273-3.28 3.276 3.276 0 0 0-3.273-3.28m-5.332 3.28a5.34 5.34 0 0 1 5.332-5.343A5.337 5.337 0 0 1 111 64.902a5.337 5.337 0 0 1-5.332 5.343 5.34 5.34 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__v)",
    fillRule: "evenodd",
    d: "M105.668 82.747a3.277 3.277 0 0 0-3.273 3.28 3.276 3.276 0 0 0 3.273 3.28 3.276 3.276 0 0 0 3.273-3.28 3.276 3.276 0 0 0-3.273-3.28m-5.332 3.28a5.34 5.34 0 0 1 5.332-5.344A5.34 5.34 0 0 1 111 86.027a5.337 5.337 0 0 1-5.332 5.343 5.34 5.34 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__w)",
    fillRule: "evenodd",
    d: "M108.55 69.213v12.502h-5.764V69.213z",
    clipRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__x)",
    fillRule: "evenodd",
    d: "M55.5 101.004a3.277 3.277 0 0 0-3.273 3.28 3.276 3.276 0 0 0 3.273 3.28 3.276 3.276 0 0 0 3.273-3.28 3.277 3.277 0 0 0-3.273-3.28m-5.332 3.28a5.337 5.337 0 0 1 5.332-5.343 5.337 5.337 0 0 1 5.332 5.343 5.337 5.337 0 0 1-5.332 5.343 5.337 5.337 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__y)",
    fillRule: "evenodd",
    d: "M22.048 122.129a3.277 3.277 0 0 0-3.273 3.28 3.276 3.276 0 0 0 3.273 3.28 3.276 3.276 0 0 0 3.273-3.28 3.277 3.277 0 0 0-3.273-3.28m-5.332 3.28a5.337 5.337 0 0 1 5.332-5.343 5.337 5.337 0 0 1 5.332 5.343 5.337 5.337 0 0 1-5.332 5.343 5.337 5.337 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__z)",
    fillRule: "evenodd",
    d: "M55.5 122.129a3.277 3.277 0 0 0-3.273 3.28 3.276 3.276 0 0 0 3.273 3.28 3.276 3.276 0 0 0 3.273-3.28 3.277 3.277 0 0 0-3.273-3.28m-5.332 3.28a5.337 5.337 0 0 1 5.332-5.343 5.337 5.337 0 0 1 5.332 5.343 5.337 5.337 0 0 1-5.332 5.343 5.337 5.337 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__A)",
    fillRule: "evenodd",
    d: "M24.93 108.596v12.502h-5.764v-12.502z",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__B)",
    fillRule: "evenodd",
    d: "M58.382 108.596v12.502h-5.764v-12.502z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__C)",
    fillRule: "evenodd",
    d: "M88.932 101.004a3.277 3.277 0 0 0-3.273 3.28 3.276 3.276 0 0 0 3.273 3.28 3.276 3.276 0 0 0 3.273-3.28 3.277 3.277 0 0 0-3.273-3.28m-5.332 3.28a5.337 5.337 0 0 1 5.332-5.343 5.337 5.337 0 0 1 5.331 5.343 5.337 5.337 0 0 1-5.331 5.343 5.337 5.337 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__D)",
    fillRule: "evenodd",
    d: "M88.932 122.129a3.277 3.277 0 0 0-3.273 3.28 3.276 3.276 0 0 0 3.273 3.28 3.276 3.276 0 0 0 3.273-3.28 3.277 3.277 0 0 0-3.273-3.28m-5.332 3.28a5.337 5.337 0 0 1 5.332-5.343 5.337 5.337 0 0 1 5.331 5.343 5.337 5.337 0 0 1-5.331 5.343 5.337 5.337 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__E)",
    fillRule: "evenodd",
    d: "M91.814 108.596v12.502H86.05v-12.502z",
    clipRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__F)",
    fillRule: "evenodd",
    d: "M88.075 50.918 77.02 63.585l-4.338-3.803 11.054-12.667z",
    clipRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__G)",
    fillRule: "evenodd",
    d: "M101.363 63.66 89.259 50.723l4.204-3.951 12.105 12.935z",
    clipRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__H)",
    fillRule: "evenodd",
    d: "M72.216 141.377a3.276 3.276 0 0 0-3.273 3.28 3.277 3.277 0 0 0 3.273 3.28 3.277 3.277 0 0 0 3.273-3.28 3.276 3.276 0 0 0-3.273-3.28m-5.332 3.28a5.337 5.337 0 0 1 5.332-5.343 5.337 5.337 0 0 1 5.332 5.343A5.337 5.337 0 0 1 72.216 150a5.337 5.337 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__I)",
    fillRule: "evenodd",
    d: "m72.812 140.123 12.27-13.368 4.242 3.91-12.27 13.368z",
    clipRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__J)",
    fillRule: "evenodd",
    d: "m59.883 126.86 11.858 13.45-4.32 3.825-11.858-13.451z",
    clipRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__K)",
    fillRule: "evenodd",
    d: "M38.784 141.067a3.277 3.277 0 0 0-3.273 3.28 3.277 3.277 0 0 0 3.273 3.281 3.277 3.277 0 0 0 3.273-3.281 3.277 3.277 0 0 0-3.273-3.28m-5.332 3.28a5.337 5.337 0 0 1 5.332-5.343 5.337 5.337 0 0 1 5.332 5.343 5.34 5.34 0 0 1-5.332 5.344 5.34 5.34 0 0 1-5.332-5.344",
    clipRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__L)",
    fillRule: "evenodd",
    d: "m39.536 140.1 11.384-13.368 4.384 3.75L43.92 143.85z",
    clipRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__M)",
    fillRule: "evenodd",
    d: "m25.618 126.844 12.331 13.265-4.218 3.938-12.33-13.265z",
    clipRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__N)",
    fillRule: "evenodd",
    d: "M83.801 103.074 73.014 90.758l4.332-3.81 10.787 12.316z",
    clipRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__O)",
    fillRule: "evenodd",
    d: "m105.541 90.747-11.179 12.647-4.314-3.83 11.178-12.647z",
    clipRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__P)",
    fillRule: "evenodd",
    d: "M89.035 21.31a3.277 3.277 0 0 0-3.273 3.28 3.277 3.277 0 0 0 3.273 3.281 3.277 3.277 0 0 0 3.273-3.28 3.277 3.277 0 0 0-3.273-3.28m-5.332 3.28a5.337 5.337 0 0 1 5.332-5.342 5.337 5.337 0 0 1 5.332 5.343 5.337 5.337 0 0 1-5.332 5.343 5.337 5.337 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__Q)",
    fillRule: "evenodd",
    d: "M86.153 41.425V28.923h5.764v12.502z",
    clipRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__R)",
    fillRule: "evenodd",
    d: "M55.603 21.31a3.277 3.277 0 0 0-3.273 3.28 3.277 3.277 0 0 0 3.273 3.281 3.277 3.277 0 0 0 3.273-3.28 3.277 3.277 0 0 0-3.273-3.28m-5.332 3.28a5.34 5.34 0 0 1 5.332-5.342 5.337 5.337 0 0 1 5.332 5.343 5.337 5.337 0 0 1-5.332 5.343 5.34 5.34 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__S)",
    fillRule: "evenodd",
    d: "M52.72 41.425V28.923h5.765v12.502z",
    clipRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__T)",
    fillRule: "evenodd",
    d: "M22.15 42.147a3.277 3.277 0 0 0-3.273 3.28 3.277 3.277 0 0 0 3.274 3.28 3.277 3.277 0 0 0 3.273-3.28 3.277 3.277 0 0 0-3.273-3.28m-5.331 3.28a5.337 5.337 0 0 1 5.332-5.343 5.337 5.337 0 0 1 5.331 5.343 5.337 5.337 0 0 1-5.331 5.343 5.337 5.337 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__U)",
    fillRule: "evenodd",
    d: "M22.15 21.022a3.277 3.277 0 0 0-3.273 3.28 3.277 3.277 0 0 0 3.274 3.28 3.277 3.277 0 0 0 3.273-3.28 3.277 3.277 0 0 0-3.273-3.28m-5.331 3.28a5.337 5.337 0 0 1 5.332-5.343 5.337 5.337 0 0 1 5.331 5.343 5.337 5.337 0 0 1-5.331 5.343 5.337 5.337 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__V)",
    fillRule: "evenodd",
    d: "M19.269 41.115V28.614h5.764v12.501z",
    clipRule: "evenodd"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__W)",
    fillRule: "evenodd",
    d: "M38.867 2.063a3.277 3.277 0 0 0-3.274 3.28 3.277 3.277 0 0 0 3.273 3.28 3.277 3.277 0 0 0 3.274-3.28 3.277 3.277 0 0 0-3.273-3.28m-5.332 3.28A5.337 5.337 0 0 1 38.867 0a5.34 5.34 0 0 1 5.331 5.343 5.34 5.34 0 0 1-5.331 5.343 5.337 5.337 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__X)",
    fillRule: "evenodd",
    d: "m38.206 9.524-11.528 13.08-4.32-3.824L33.886 5.7z",
    clipRule: "evenodd"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__Y)",
    fillRule: "evenodd",
    d: "M51.034 22.934 39.527 9.874l4.32-3.823 11.508 13.06z",
    clipRule: "evenodd"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__Z)",
    fillRule: "evenodd",
    d: "M72.319 2.063a3.277 3.277 0 0 0-3.273 3.28 3.277 3.277 0 0 0 3.273 3.28 3.277 3.277 0 0 0 3.273-3.28 3.277 3.277 0 0 0-3.273-3.28m-5.332 3.28A5.34 5.34 0 0 1 72.319 0a5.337 5.337 0 0 1 5.332 5.343 5.337 5.337 0 0 1-5.332 5.343 5.34 5.34 0 0 1-5.332-5.343",
    clipRule: "evenodd"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__aa)",
    fillRule: "evenodd",
    d: "m71.55 9.784-10.87 13.41-4.473-3.642 10.87-13.41z",
    clipRule: "evenodd"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Problem_5_svg__ab)",
    fillRule: "evenodd",
    d: "M84.413 22.917 72.906 9.405l4.384-3.75 11.508 13.513z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__a",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__b",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__c",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__d",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__e",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__f",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__g",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__h",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__i",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__j",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__k",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__l",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__m",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__n",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__o",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__p",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__q",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__r",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__s",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__t",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__u",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__v",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__w",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__x",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__y",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__z",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__A",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__B",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__C",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__D",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__E",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__F",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__G",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__H",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__I",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__J",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__K",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__L",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__M",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__N",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__O",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__P",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__Q",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__R",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__S",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__T",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__U",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__V",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__W",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__X",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__Y",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__Z",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__aa",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Problem_5_svg__ab",
    x1: 55.5,
    x2: 55.5,
    y1: 0,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })))));
};
export default SvgProblem5;